import {isNoValue} from '@/utils/util'
const channel = {
  state: {
    staticParams: {
      endDate: null,
      forecastType: null,
      startDate: null,
      number: 1,
      size: 10
    },
    enrollInfoParams: {
      endDate: null,
      startDate: null,
      number: 1,
      size: 10
    },
    preEnrollInfoParams: {
      endDate: null,
      startDate: null,
      number: 1,
      size: 10
    }
  },
  getters: {
    channelStaticParams: (state) => {
      return state.staticParams
    },
    formatedChannelStaticParams: (state) => {
      let result = {}
      for (const key in state.staticParams) {
        const element = state.staticParams[key]
        if (!isNoValue(element)) result[key] = element
      }
      return result
    },
    channelEnrollInfoParams: (state) => {
      return state.enrollInfoParams
    },
    formatedChannelEnrollInfoParams: (state) => {
      let result = {}
      for (const key in state.enrollInfoParams) {
        const element = state.enrollInfoParams[key]
        if (!isNoValue(element)) result[key] = element
      }
      return result
    },
    channelPreEnrollInfoParams: (state) => {
      return state.preEnrollInfoParams
    },
    formatedPreChannelEnrollInfoParams: (state) => {
      let result = {}
      for (const key in state.preEnrollInfoParams) {
        const element = state.preEnrollInfoParams[key]
        if (!isNoValue(element)) result[key] = element
      }
      return result
    }
  },
  mutations: {
  },
  actions: {
  }
}

export default channel



// WEBPACK FOOTER //
// ./src/store/modules/channel.js